import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SpendLensItemMetricCardResponseModel } from '@/types/clarityLens'

export const getSpendLensItemMetricCard = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemName: string
): Promise<SpendLensItemMetricCardResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/spend-lens/item/metric-card`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          dcn: branchName,
          item_name: itemName,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
